import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';

type LiStyleProps = { disabled?: boolean };

const liBaseStyle = css`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: ${theme.spacing(2)};
  text-transform: capitalize;
  transition: background-color 250ms ease-out;

  &:hover,
  &:focus {
    background-color: ${theme.colors.neutral10};
    outline: none;
  }

  &:not(:last-of-type) {
    border-bottom: 1px solid ${theme.colors.neutral20};
  }
`;

const liDisabledStyle = css`
  background-color: ${theme.colors.status.disabled};
  cursor: default;
  pointer-events: none;
  opacity: 0.5;

  &:hover,
  &:focus {
    background-color: ${theme.colors.status.disabled};
    outline: none;
  }
`;

const iconStyle = css`
  line-height: 1;
  margin-right: ${theme.spacing(1)};
`;

export const FlyoutMenuItemStyles = {
  liStyle: ({ disabled }: LiStyleProps): string => cx(liBaseStyle, disabled && liDisabledStyle),
  iconStyle,
};
